export default "__VITE_ASSET___p9xfsWx__"